import { FromToRange, type FromToRangeProps } from "components/ui/FromToRange";
import {
  type Control,
  type FieldPath,
  type FieldValues,
  useController,
} from "react-hook-form";

export type RhfFromToRangeProps<T extends FieldValues> = {
  nameFrom: FieldPath<T>;
  nameTo: FieldPath<T>;
  control?: Control<T>;
} & Omit<
  FromToRangeProps,
  "fromValue" | "toValue" | "onFromChange" | "onToChange"
>;

/**
 * React Hook Form アダプタ for FromToRange。2つのフィールドを同時に扱う。
 * @param {RhfFromToRangeProps<T>} props props
 * @return {JSX.Element} 接続された FromToRange
 */
export function RhfFromToRange<T extends FieldValues>({
  nameFrom,
  nameTo,
  control,
  ...rest
}: RhfFromToRangeProps<T>): JSX.Element {
  const fromCtrl = useController<T>({ name: nameFrom, control });
  const toCtrl = useController<T>({ name: nameTo, control });

  return (
    <FromToRange
      {...rest}
      fromValue={Number(fromCtrl.field.value)}
      toValue={Number(toCtrl.field.value)}
      onFromChange={fromCtrl.field.onChange}
      onToChange={toCtrl.field.onChange}
    />
  );
}
